import React from 'react'
import { useTheme } from '@mui/material/styles'

import MultiSelectWithSearch from 'components/Shared/MultiSelectWithSearch'
import { AdminUITheme } from 'types/AdminUiThemeMui'
import { useAppDispatch, useAppSelector } from 'redux/Hook'
import { FilterItem } from 'types/FilterBuilder'
import { updateFilter } from 'redux/slices/FilterBuilder'

type Props = {
  item: FilterItem
  index: number
  context?: any
}

const ProjectTag = (props: Props) => {
  const { item, index } = props
  const { defaultOpen } = item
  const dispatch = useAppDispatch()

  const projectTags = useAppSelector((state) => state.projectTags.data)

  const getSelectedTags = () => {
    if (item.value) {
      return item.value.split(',')?.map((project_tag: string) => {
        return { name: project_tag }
      })
    }

    return []
  }

  const handleFilterByProjectTag = (value: Tags) => {
    const tagsString = value.map((v: { name: string }) => v.name).toString()
    dispatch(updateFilter({ item: { value: tagsString }, index }))
  }

  const isOptionEqualToValue = (
    option: { name: string },
    value: { name: string },
  ) => {
    return option.name === value.name
  }

  const theme: AdminUITheme = useTheme()

  return (
    <MultiSelectWithSearch
      style={theme.GenericTheme.dynamicFilterWrapperWidth}
      selectedValues={getSelectedTags()}
      options={projectTags}
      isOptionEqualToValue={isOptionEqualToValue}
      handleOnChange={handleFilterByProjectTag}
      defaultOpen={defaultOpen}
      optionKey="name"
      dataCyLabel="project_tags"
      labelKey="filters.projectTag.label"
      placeholderKey="filters.search"
    />
  )
}

export default ProjectTag
